import GuestListActions from '../../../actions/GuestListActions';
import PopupActions from '../../../actions/PopupActions';

import GuestListStore from '../../../stores/GuestListStore';
import UserStore from '../../../stores/UserStore';

import CheckIn from '../sidebar/CheckIn.react';
import CheckInToPos from '../sidebar/CheckInToPos.react';
import CheckOut from '../sidebar/CheckOut.react';
import EnterPos from '../sidebar/EnterPos.react';
import NewTransaction from '../sidebar/NewTransaction.react';

import EditImage from '../../popup/EditImage.react';
import PosCartActions from '../../../actions/PosCartActions';
import CheckInCaregiver from '../sidebar/CheckInCaregiver.react';

import BirthdateCheckModal from '../../pos/checkout/BrithdateCheckModal';

class ProfileSidebar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            showId: false,
            showEditImage: false,
            profileChanged: false,
        };

        this.setLoading = this.setLoading.bind(this);
    }

    updateSaveButton(change) {
        this.setState({ profileChanged: !!change });
    }

    setLoading(loading, callback) {
        this.setState({ loading }, callback);
    }

    render() {
        let guest = this.props.guest;
        let page = this.props.page;
        let selectedLocation = this.props.selectedLocation;

        let idImg = false;
        for (let i = 0; i < guest.identifications.length; i++) {
            if (guest.identifications[i].type === 'MJStateIDNo')
                idImg = guest.identifications[i].image_url;
        }

        let isGuestCheckedIn = guest
            ? GuestListStore.getGuestById(guest.Guest_id)
            : false;

        return [
            <div className="profile-sidebar">
                <div className="profile-sidebar__nav">
                    <div
                        className={
                            'profile-sidebar__item ' + (page === 'personal' ? 'profile-sidebar__item--selected' : '')
                        }
                        onClick={() => {
                            this.props.goToPage('personal');
                        }}
                    >
                        {page === 'personal' && ( <div className="profile-sidebar__item--triangle" /> )}
                        {selectedLocation.CompanyFlag === 'Dispensary'
                            ? 'Personal Info'
                            : 'Customer Profile'}
                    </div>

                    <div
                        className={
                            'profile-sidebar__item ' +
                            (page === 'medical'
                                ? 'profile-sidebar__item--selected'
                                : '')
                        }
                        onClick={() => {
                            this.props.goToPage('medical');
                        }}
                    >
                        {page === 'medical' && (
                            <div className="profile-sidebar__item--triangle" />
                        )}
                        {selectedLocation.CompanyFlag === 'Dispensary'
                            ? 'Medical Info'
                            : 'Notes and Comments'}
                    </div>

                    <div
                        className={
                            'profile-sidebar__item ' +
                            (page === 'identification'
                                ? 'profile-sidebar__item--selected'
                                : '')
                        }
                        onClick={() => {
                            this.props.goToPage('identification');
                        }}
                    >
                        {page === 'identification' && (
                            <div className="profile-sidebar__item--triangle" />
                        )}
                        Identification
                    </div>

                    <div
                        className={
                            'profile-sidebar__item ' +
                            (page === 'history'
                                ? 'profile-sidebar__item--selected'
                                : '')
                        }
                        onClick={() => {
                            this.props.goToPage('history');
                        }}
                    >
                        {page === 'history' && (
                            <div className="profile-sidebar__item--triangle" />
                        )}
                        History
                    </div>

                    <div
                        className={
                            'profile-sidebar__item ' +
                            (page === 'journal'
                                ? 'profile-sidebar__item--selected'
                                : '')
                        }
                        onClick={() => {
                            PopupActions.patientJournal(guest);
                        }}
                    >
                        {page === 'journal' && (
                            <div className="profile-sidebar__item--triangle" />
                        )}
                        Journal
                    </div>

                    {UserStore.getState().selectedLocation
                        .RequirePolicySignature && (
                        <div
                            className={
                                'profile-sidebar__item ' +
                                (page === 'policy'
                                    ? 'profile-sidebar__item--selected'
                                    : '')
                            }
                            onClick={() => {
                                this.props.goToPage('policy');
                            }}
                        >
                            {page === 'policy' && (
                                <div className="profile-sidebar__item--triangle" />
                            )}
                            Patient Policy
                        </div>
                    )}
                </div>

                {idImg ? (
                    <img
                        src={'data:image/png;base64, ' + idImg}
                        className="profile-sidebar__id"
                        onClick={() => {
                            this.setState({ showEditImage: true });
                        }}
                    />
                ) : (
                    <img
                        src="/assets/id_placeholder.png"
                        className="profile-sidebar__id"
                    />
                )}

                <div className="profile-sidebar__name">{guest.FullName}</div>

                <div className="profile-sidebar__back">
                    <button
                        className={
                            'btn-green ' +
                            (this.state.profileChanged
                                ? ''
                                : 'btn-green__disabled')
                        }
                        id={'SaveCustomerProfile_' + guest.Guest_id}
                        onClick={() => {
                            this.props.saveChanges();
                        }}
                    >
                        SAVE CHANGES
                    </button>
                    
                    { selectedLocation.RegisterForLoyaltyPopup && !guest.IsLoyaltyMember && !guest.IsAnonymous &&
                        <button className={'btn-green'}
                            onClick={() => PopupActions.open('loyalty-registration', guest, guest)}
                        >
                            REGISTER FOR LOYALTY
                        </button>
                    }

                    { this.state.showBirthdateCheck &&
                          <BirthdateCheckModal 
                                guest={guest}
                                UserId={UserStore.getState().user.UserId}
                                onClose={(success) => {
                                    this.setState({ showBirthdateCheck: false, birthdateCheckComplete: success})
                                }}
                            />
                    }
                
                    { (selectedLocation.ConfirmBirthdayOnCheckin && !this.state.birthdateCheckComplete) &&
                        <div>
                            <button
                                className={'btn-green'}
                                onClick={() => { this.setState({ showBirthdateCheck: true }); }}
                                disabled={false}>
            
                                VERIFY BIRTHDATE
                            </button>
                        </div>
                            
                        
                    }

                    { (!selectedLocation.ConfirmBirthdayOnCheckin || this.state.birthdateCheckComplete) && !isGuestCheckedIn && (
                        <CheckInCaregiver
                            guest={guest}
                            setLoading={this.setLoading}
                            loading={this.state.loading}
                            selectedLocation={selectedLocation}
                        />
                    )}

                    {isGuestCheckedIn ? (
                        <CheckOut
                            guest={guest}
                            loading={this.state.loading}
                            selectedLocation={selectedLocation}
                        />
                    ) : (
                        (!selectedLocation.ConfirmBirthdayOnCheckin || this.state.birthdateCheckComplete) ? <CheckIn
                            guest={guest}
                            setLoading={this.setLoading}
                            loading={this.state.loading}
                            selectedLocation={selectedLocation}
                        /> : null
                    )}

                    {isGuestCheckedIn ? (
                        <EnterPos guest={guest} loading={this.state.loading} />
                    ) : (
                        (!selectedLocation.ConfirmBirthdayOnCheckin || this.state.birthdateCheckComplete) ? <CheckInToPos
                            guest={guest}
                            setLoading={this.setLoading}
                            loading={this.state.loading}
                        /> : null
                    )}

                    {(!selectedLocation.ConfirmBirthdayOnCheckin || this.state.birthdateCheckComplete) && !isGuestCheckedIn && selectedLocation.NewTransaction && (
                        <NewTransaction
                            guest={guest}
                            setLoading={this.setLoading}
                            loading={this.state.loading}
                        />
                    )}

                    <button
                        className="btn-green"
                        onClick={() => {
                            if (guest.ShipmentId) {
                                PosCartActions.loadUserCart(
                                    guest.Guest_id,
                                    guest.ShipmentId
                                );
                            }
                            PopupActions.close();
                            GuestListActions.loadGuestList();

                        }}
                        style={{ marginBottom: '10px' }}
                    >
                        BACK
                    </button>
                </div>

                {this.state.showId && (
                    <div
                        className="pos-profile__id"
                        onClick={() => {
                            this.setState({ showId: false }, () => {
                                $('.pos-sidebar').css({ 'z-index': 2 });
                            });
                        }}
                    >
                        <img src={'data:image/png;base64, ' + idImg} />
                    </div>
                )}
            </div>,

            this.state.showEditImage && (
                <EditImage
                    guest={guest}
                    data={idImg}
                    onClose={() => {
                        this.setState({ showEditImage: false });
                    }}
                />
            ),
        ];
    }
}

export default ProfileSidebar;



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/ProfileSidebar.react.jsx